
export default {
    data() {
        return {};
    },
    methods: {
        getFilterValues(reset = false) {
            if (reset) {
                this.setFilterValue(true);
                this.queryParams = { perpage: 25 };
            } else {
                const previousFilterValues = JSON.parse(window.localStorage.getItem(this.filterName));
                if (previousFilterValues) {
                    Object.keys(previousFilterValues).forEach(key => {
                        this.setFilterValue(false, previousFilterValues, key);
                    });

                    this.queryParams = { ...this.queryParams, ...previousFilterValues };
                }
            }
        },
        setFilterValue(reset, previousFilterValues, key) {
            this.filters = this.filters.map(element => {
                if (reset) {
                    return { ...element };
                }
                if (element.key === key) {
                    return { ...element, value: previousFilterValues[key] };
                }

                if (element.key === 'date') {
                    return { ...element, value: [previousFilterValues.startDate, previousFilterValues.endDate] };
                }

                if (element.key === 'collectedDate') {
                    return { ...element, value: [previousFilterValues.collectedStartDate, previousFilterValues.collectedEndDate] };
                }

                if (element.key === 'receivedDate') {
                    return { ...element, value: [previousFilterValues.receivedStartDate, previousFilterValues.receivedEndDate] };
                }

                return element;
            });
        },
    },
};
